const transactions = [
    {
        "id": "01e39a9c-a4ff-3429-a079-968ad1bbb0a3",
        "description": "ALETIHAD CREDIT BUREAU ABU DHABI AE",
        "amount": -45000.00,
        "currency_code": "AED",
        "pending": false,
        "timestamp": "2021-01-31T00:00:00Z",
        "insights": {
            "description_cleansed": "ALETIHAD CREDIT BUREAU",
            "category": "LOANS_AND_INVESTMENTS",
            "category_confidence": 0.99,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "1f72f549-ea3c-3459-a71a-5440393e2b62",
        "description": "POS-PURCHASE CARD NO.4******1 10098959 14-03-2020 SUMO SUSHI & BENTO DUBAI AE",
        "amount": -54.89,
        "currency_code": "AED",
        "pending": false,
        "timestamp": "2020-08-06T00:00:00Z",
        "insights": {
            "description_cleansed": "SUMO SUSHI BENTO",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "1f72f549-ea3c-3459-a71a-5440393e2b62",
        "description": "TRANSFER FROM BARRETT WALLACE /REF/MARLENES SCHOOL MONEY",
        "amount": 1800.49,
        "currency_code": "AED",
        "pending": false,
        "timestamp": "2020-08-06T00:00:00Z",
        "insights": {
            "description_cleansed": "BARRETT WALLACE",
            "category": "SALARY_REVENUE",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "e0dbc14e-2377-3b25-b57b-af48622b939a",
        "description": "AMERICAN UNIVERSITY IN THE EMIRA DUBAI ARE",
        "amount": -10000.12,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2020-05-18T00:00:00Z",
        "insights": {
            "description_cleansed": "AMERICAN UNIVERSITY IN THE EMIRATES",
            "category": "EDUCATION",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "0426f10f-6c64-3368-8180-e402446789d3",
        "description": "SUBWAY GRU T3 GUARULHOS BRA",
        "amount": -16.63,
        "currency_code": "AED",
        "pending": false,
        "timestamp": "2018-10-23T00:00:00Z",
        "insights": {
            "description_cleansed": "SUBWAY",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "06801fd6-9bc4-340b-9367-de097deec5ec",
        "description": "ABU DHABI TOURISM AUTHORI DUBAI ARE",
        "amount": -444.11,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2019-11-17T00:00:00Z",
        "insights": {
            "description_cleansed": "ABU DHABI TOURISM AUTHORITY",
            "category": "TRAVEL",
            "category_confidence": 0.71,
            "type": "TRANSFER",
            "type_confidence": 0.99
        }
    },
    {
        "id": "578b5f6c-f64e-3832-a86a-157a6a82682a",
        "description": "TELEGRAPHIC TRF REF NUM:O***********0 FITBAR RESTAURANT /REF/Fitbar Arsalan",
        "amount": -279.47,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2019-02-26T00:00:00Z",
        "insights": {
            "description_cleansed": "FITBAR",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 0.96,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "e49cef5e-5770-3261-be7e-b03f58a87052",
        "description": "SUBWAY FUJAIRAH ARE",
        "amount": -22.57,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2020-07-13T00:00:00Z",
        "insights": {
            "description_cleansed": "SUBWAY",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 0.99,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "00d8e574-5faf-38a5-8182-5d1faf81cffb",
        "description": "UNIQLO KLCC KUALA LUMPUR MYS",
        "amount": -95.54,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2018-07-09T00:00:00Z",
        "insights": {
            "description_cleansed": "UNIQLO",
            "category": "RETAIL",
            "category_confidence": 1,
            "type": "TRANSFER",
            "type_confidence": 1
        }
    },
    {
        "id": "76965310-9436-38b8-ac87-671e0639854b",
        "description": "POS-PURCHASE CARD NO.4*****************0 120907 12-02-2020 3.69-AED APPLE.COM/BILL ITUNES.COM:IE",
        "amount": -12.99,
        "currency_code": "AED",
        "pending": true,
        "timestamp": "2020-12-15T00:00:00Z",
        "insights": {
            "description_cleansed": "APPLE",
            "category": "ENTERTAINMENT",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    },
    {
        "id": "5192a3e5-b6f0-38d3-afba-d0040fd2b7cb",
        "description": "POS-PURCHASE CARD NO.4*************6311 115772 28-11-2019 46.90-AED DELIVEROO DMCC DUBAI:AE",
        "amount": -37.18,
        "currency_code": "AED",
        "pending": false,
        "timestamp": "2019-08-22T00:00:00Z",
        "insights": {
            "description_cleansed": "DELIVEROO",
            "category": "RESTAURANTS_DINING",
            "category_confidence": 1,
            "type": "CARD",
            "type_confidence": 1
        }
    }
]

export default transactions